import { render, staticRenderFns } from "./truck_add.vue?vue&type=template&id=befd9f08&scoped=true&"
import script from "./truck_add.vue?vue&type=script&lang=js&"
export * from "./truck_add.vue?vue&type=script&lang=js&"
import style0 from "./truck_add.vue?vue&type=style&index=0&id=befd9f08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befd9f08",
  null
  
)

export default component.exports